import React, { Fragment, useEffect, useState } from "react";
import { formatMoney } from "../../../../helpers/formatter";
import moment from "moment";
import { useSelector } from "react-redux";
import { ROLE_TYPES } from "../../../../helpers/roleTypes";
import { postDataWithDotNet } from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { errorHandler } from "../../../../helpers/errorHandler";
import { APPROVE_INVESTMENT_ADMIN_TOP_UP } from "../../../../api/ajax-endpoints";
import { MixPanel } from "../../../../shared/MixPanel/MixPanel";

export interface topUpData {
  funder_investment_id: number;
  top_up_amount: number;
  transaction_date: string;
  topup_type: number;
  top_up_type_name: string;
  proof_of_payment_path: string;
  wallet_id: string;
  currency_code: string;
  narration: string;
  reference: string;
  user_id: number;
  investment_product_name: string;
  deposit_type: string;
  investment_reference_number: string;
  funder_id: number;
  funder_type: number;
  firstname: string;
  lastname: string;
  email: string;
  phone_number: string;
  biz_name: string;
  biz_email: string;
  funder_document_id: number;
  internal_transaction_reference: string;
  initiator: "investor" | "admin";
}

interface IProps {
  properties: { item: topUpData };
  onCloseModal: () => void;
}
const InvestmentTopUpRequestModal = ({ properties, onCloseModal }: IProps) => {
  const {
    top_up_amount,
    email,
    currency_code,
    funder_investment_id,
    funder_id,
    funder_type,
    deposit_type,
    investment_reference_number,
    reference,
    investment_product_name,
    topup_type,
    phone_number,
    transaction_date,
    lastname,
    narration,
    user_id,
    proof_of_payment_path,
    wallet_id,
    firstname,
    initiator,
  } = properties?.item;
  const loggedInUser = useSelector(
    (state: any) => state?.authReducer?.loggedInUser,
  );
  const { roles } = loggedInUser;

  useEffect(() => {
    MixPanel.track(`Page View: InvestmentTopUpRequest.tsx`, {
      page: "InvestmentTopUpRequest.tsx",
    });
  }, []);

  const [comment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isFormValid, setIsFormValid] = useState(true);
  const [topUpSuccess, setTopUpSuccess] = useState("");
  const [error, setError] = useState("");
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);

  const submitHandleApprove = async () => {
    if (!comment) {
      return setIsFormValid(false);
    }
    try {
      setApproving(true);
      const response = await postDataWithDotNet(
        initiator === "investor"
          ? ajaxEndpoints.APPROVE_INVESTMENT_INVESTOR_TOP_UP
          : ajaxEndpoints.APPROVE_INVESTMENT_ADMIN_TOP_UP,
        {
          comment,
          reference: reference,
        },
      );
      //TODO : - Confirm which of the two targets the message from api and remove the invalid one
      setTopUpSuccess(response?.data?.message || response?.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      setError(errorHandler(error));
    } finally {
      setApproving(false);
    }
  };
  const submitHandleReject = async () => {
    if (!comment) {
      return setIsFormValid(false);
    }
    try {
      setRejecting(true);
      const response = await postDataWithDotNet(
        ajaxEndpoints.REJECT_INVESTMENT_TOP_UP_AND_WITHDRAWAL,
        {
          comment,
          reference: reference,
        },
      );
      //TODO : - Confirm which of the two targets the message from api and remove the invalid one
      setTopUpSuccess(response?.data?.message || response?.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      onCloseModal();
    } catch (error) {
      setError(errorHandler(error));
      setTimeout(() => {
        setError("");
      }, 2000);
      console.log(error);
    } finally {
      setRejecting(false);
    }
  };

  return (
    <div
      className="AuditTrailModal Modal__content"
      style={{ overflow: "hidden" }}
    >
      <div className="Modal__body">
        <Fragment>
          <h3 className="Modal__title p-b-1">Top Up Request</h3>
          <hr />
          <div className="row">
            {/* Top-up Amount */}
            <div className="col-md-6 mb-3">
              <label>Top-up Amount:</label>
              <input
                type="text"
                className="form-control"
                value={formatMoney(top_up_amount || 0, currency_code)}
                readOnly
              />
            </div>
            {/* Funder Investment ID */}
            <div className="col-md-6 mb-3">
              <label>Funder Investment ID:</label>
              <input
                type="text"
                className="form-control"
                value={funder_investment_id}
                readOnly
              />
            </div>
            {/* Transaction Date */}
            <div className="col-md-6 mb-3">
              <label>Transaction Date:</label>
              <input
                type="text"
                className="form-control"
                value={moment(transaction_date).format("LL")}
                readOnly
              />
            </div>
            {/* Top-Up Type */}
            <div className="col-md-6 mb-3">
              <label>Top-Up Type:</label>
              <input
                type="text"
                className="form-control"
                value={topup_type}
                readOnly
              />
            </div>
            {/* Wallet ID */}
            <div className="col-md-6 mb-3">
              <label>Wallet ID:</label>
              <input
                type="text"
                className="form-control"
                value={wallet_id}
                readOnly
              />
            </div>
            {/* Narration */}
            <div className="col-md-6 mb-3">
              <label>Narration:</label>
              <input
                type="text"
                className="form-control"
                value={narration}
                readOnly
              />
            </div>
            {/* Reference */}
            <div className="col-md-6 mb-3">
              <label>Reference:</label>
              <input
                type="text"
                className="form-control"
                value={reference}
                readOnly
              />
            </div>
            {/* User ID */}
            <div className="col-md-6 mb-3">
              <label>User ID:</label>
              <input
                type="text"
                className="form-control"
                value={user_id}
                readOnly
              />
            </div>
            {/* Investment Product Name */}
            <div className="col-md-6 mb-3">
              <label>Investment Product Name:</label>
              <input
                type="text"
                className="form-control"
                value={investment_product_name}
                readOnly
              />
            </div>
            {/* Deposit Type */}
            <div className="col-md-6 mb-3">
              <label>Deposit Type:</label>
              <input
                type="text"
                className="form-control"
                value={deposit_type}
                readOnly
              />
            </div>
            {/* Investment Reference Number */}
            <div className="col-md-6 mb-3">
              <label>Investment Reference Number:</label>
              <input
                type="text"
                className="form-control"
                value={investment_reference_number}
                readOnly
              />
            </div>
            {/* Funder ID */}
            <div className="col-md-6 mb-3">
              <label>Funder ID:</label>
              <input
                type="text"
                className="form-control"
                value={funder_id}
                readOnly
              />
            </div>
            {/* Funder Type */}
            <div className="col-md-6 mb-3">
              <label>Funder Type:</label>
              <input
                type="text"
                className="form-control"
                value={funder_type}
                readOnly
              />
            </div>
            {/* First Name */}
            <div className="col-md-6 mb-3">
              <label>First Name:</label>
              <input
                type="text"
                className="form-control"
                value={firstname}
                readOnly
              />
            </div>
            {/* Last Name */}
            <div className="col-md-6 mb-3">
              <label>Last Name:</label>
              <input
                type="text"
                className="form-control"
                value={lastname}
                readOnly
              />
            </div>
            {/* Email */}
            <div className="col-md-6 mb-3">
              <label>Email:</label>
              <input
                type="text"
                className="form-control"
                value={email}
                readOnly
              />
            </div>
            {/* Phone Number */}
            <div className="col-md-6 mb-3">
              <label>Phone Number:</label>
              <input
                type="text"
                className="form-control"
                value={phone_number}
                readOnly
              />
            </div>
            <div className="col-md-6 mb-3">
              <label>Comment</label>
              <input
                type="text"
                className="form-control"
                name="comment"
                defaultValue={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                  setIsFormValid(true);
                }}
              ></input>
              {!isFormValid && <p className="text-danger">Enter a comment</p>}
            </div>
            {proof_of_payment_path && (
              <div className="col-md-6 mb-3">
                <div>
                  <img
                    src={proof_of_payment_path}
                    alt="Proof of Payment"
                    className="img-fluid"
                  />
                </div>
              </div>
            )}
          </div>
          {roles &&
            roles?.length > 0 &&
            roles?.includes(ROLE_TYPES.INVESTMENT_TOP_UP_APPROVER) && (
              <>
                <hr />
                {topUpSuccess && (
                  <p className="alert alert-success col-md-6 offset-md-3">
                    {topUpSuccess}
                  </p>
                )}

                {error && (
                  <p className="alert alert-danger col-md-6 offset-md-3">
                    {error}
                  </p>
                )}
                <div className="col-12 d-flex justify-content-end flex-wrap">
                  <button
                    className="btn advancly-btn btn-sm transition-3d-hover mt-2 mr-2"
                    type="button"
                    disabled={
                      isLoading ||
                      !comment ||
                      !reference ||
                      approving ||
                      rejecting
                    }
                    onClick={submitHandleApprove}
                  >
                    {approving ? (
                      <span className="spinner-border spinner-border-sm text-white" />
                    ) : (
                      "Approve"
                    )}
                  </button>
                  <button
                    className="btn advancly-dimred-btn btn-sm transition-3d-hover mt-2"
                    type="submit"
                    disabled={
                      isLoading ||
                      !comment ||
                      !reference ||
                      approving ||
                      rejecting
                    }
                    onClick={submitHandleReject}
                  >
                    {rejecting ? (
                      <span className="spinner-border spinner-border-sm text-white" />
                    ) : (
                      "Reject"
                    )}
                  </button>
                </div>
              </>
            )}
        </Fragment>
      </div>
    </div>
  );
};
export default InvestmentTopUpRequestModal;
